module.exports = __webpack_public_path__ + "static/media/RationalDisplay-Medium.3fca0521.woff";